import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { GlobalModule } from '@app/_global/global.module';
import { HTMLEditorModule } from '@app/components/html-editor';
import { Texte } from '@app/texte/texte.model';
import { EventManagerService, IEventListener } from '@global/event-manager.service';

import { uid } from '@helpers/utils';

@Component({
	selector: 'commentaire-texte-dialog',
	template: `
		<div class="w-full readonly-texte">
			<html-editor
				name="txt_commentaire"
				[(ngModel)]="texte.txt_commentaire"
				[readonly]="true"
				class="mt-1 no-padding-html-view no-border-html-view"
			></html-editor>
		</div>
	`,
	providers: []
})
export class CommentaireTexteDialogComponent implements OnInit, IEventListener {

	private _uuid: string = uid();
	get uuid(): string { return this._uuid; }

	texte: Texte;

	constructor(
		private config: DynamicDialogConfig,
		private dialogRef: DynamicDialogRef,
		private eventManager: EventManagerService,
	) {
		this.texte = config.data.texte;
	}

	ngOnInit(): void {
		this.eventManager.registerEvent('close-modals', this, (args: any) => {
			this.dialogRef.close();
		});
	}

	ngOnDestroy(): void {
		this.eventManager.unregisterEvent('close-modals', this);
	}
}


@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		GlobalModule,
		HTMLEditorModule
	],
	exports: [CommentaireTexteDialogComponent],
	declarations: [CommentaireTexteDialogComponent]
})
export class CommentaireTexteDialogModule { }

